// extracted by mini-css-extract-plugin
export default {"text":"vacancy-drop-down_text__iMj1V","input":"vacancy-drop-down_input__z7mue","placeholder":"vacancy-drop-down_placeholder__QQSwl"};